<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.APPLICANT_INFORMATION }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg>
          </span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :initial-values="form"
              :validation-schema="schema">

          <div class="input__group">
            <label for="user-input" class="label">{{ $lang.app.EMAIL }}</label>
            <div class="input__wrapper">
              <Field name="user" v-slot="{ field, errorMessage }">
                <input v-bind="field"
                       type="email"
                       id="user-input"
                       v-model="form.user"
                       class="input"
                       :class="{'input--fail': errorMessage }"
                       :placeholder="$lang.app.ENTER">
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
              <button type="button" class="input__button" @click="findApplicant">{{ $lang.app.FIND }}</button>
            </div>
            <div v-if="form.info"
                 class="flex items-center mt-2 rounded-md text-white bg-green-400 px-4 py-2 font-medium text-lg">
              <CheckIcon class="w-10 h-10 flex-shrink-0 mr-4"/>
              <div>
                <p>{{ $lang.app[userTypesGetLabelRefByValue(form.info.type)] }}</p>
                <p>{{ form.info.username }}</p>
              </div>
            </div>
          </div>
          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel" @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.REASSIGN }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>

        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import * as yup from "yup";
import {Field, Form} from 'vee-validate';
import applicationApi from "../../../../api/applicant/application";
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../../helpers/constants/userTypes";
import applicantApi from "../../../../api/applicant/applicant";

export default {
  name: 'ApplicantApplicationApplicantReassignModal',
  components: {
    Field,
    Form,
  },
  data() {
    return {
      showModal: false,
      applicant: null,

      submitting: false,

      form: null,

      schema: yup.object({
        user: yup.string().required(),
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-applicant-application-applicant-reassign-modal', (applicant) => {
      this.applicant = applicant
      this.form = {
        user: applicant.login,
        info: null,
      }

      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-applicant-application-applicant-reassign-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,

    findApplicant() {
      this.form.info = null
      applicantApi.findByEmail({email: this.form.user})
          .then(res => {
            this.form.info = {
              type: res.userInfo.type,
              username: this.getCustomerFullName(res.userInfo)
            }
          }).catch(error => {
        this.$snotify.error(error.response.data.message)
      })
    },

    getCustomerFullName(userInfo) {
      if(userInfo.type === this.userTypesGetValueByKey('INDIVIDUAL_ENTITY')) {
        return userInfo.person.surname + ' ' + userInfo.person.name + ' ' + userInfo.person.patronymic
      }
      if(userInfo.type === this.userTypesGetValueByKey('LEGAL_ENTITY')) {
        return this.$lang.$translate({ru: userInfo.organization.nameRu, kg: userInfo.organization.nameKg})
      }
      if(userInfo.type === this.userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')) {
        return userInfo.individualEnterprise.surname + ' ' + userInfo.individualEnterprise.name + ' ' + userInfo.individualEnterprise.patronymic
      }
    },

    async submit(values, actions) {
      this.submitting = true
      applicationApi.reassignApplicant(this.$route.params.applicationId, {
        user: this.form.user,
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              actions.setErrors(error.response.data.errors);
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(error.response.data.message)
            }
          }).finally(() => {
            this.openModal()
      })
    }
  }
}
</script>
